var render, staticRenderFns
import script from "./ValidationMixin.vue?vue&type=script&lang=ts&"
export * from "./ValidationMixin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports